import React from 'react'
import { useTranslation } from 'react-i18next'
import * as R from 'ramda'

import type { DiagnosisSnapshotItem } from '~/types'

import RhapProblemHistoryEntry from './RhapProblemHistoryEntry'

import '@chewy/kib-tooltip-styles/dist/kib-tooltip.css'
import styles from './RhapProblemHistoryPanel.module.scss'

interface RhapProblemHistoryPanelProps {
  clientId: string
  patientId: string
  problemLogs: DiagnosisSnapshotItem[]
}

const RhapProblemHistoryPanel: React.FC<RhapProblemHistoryPanelProps> = ({
  problemLogs,
  clientId,
  patientId,
}) => {
  const { t } = useTranslation()

  const statusEntries = R.pipe(
    R.groupBy((problem: DiagnosisSnapshotItem) =>
      problem.soapId
        ? `${problem.statusId}${problem.type}`
        : problem.diagnosedIn,
    ),
    R.values,
  )(problemLogs)

  return (
    <>
      <div className={styles.heading}>{t('Common:DIAGNOSIS_HISTORY')}</div>
      {statusEntries.map((logs) => (
        <RhapProblemHistoryEntry
          clientId={clientId}
          key={`${logs[0].id} ${logs[0].date}`}
          logs={logs}
          patientId={patientId}
        />
      ))}
    </>
  )
}

export default RhapProblemHistoryPanel
